import React from "react"
import logoUrl from "../../../assets/img/payment-icons/discover.svg"

export default function DiscoverLogo({ sx }: { sx: React.CSSProperties }) {
    return (
        <img
            src={logoUrl} loading="lazy"
            alt="Discover logo"
            style={sx}
        />
    )
}
